import React from 'react';
import { AppTokenConsumer } from '../../contexts/AppTokenContext';
import LocationSelector from './LocationSelector';

export default function HomePage() {
  return (
    <>
      <AppTokenConsumer>
        {
          (accessToken) => {
            return <LocationSelector authToken={accessToken} />
          }
        }
      </AppTokenConsumer>
    </>
  );
}
